/**
 * A local `Blob` + `URL.createObjectURL` + a synthetic `<a download>` — 15 lines instead of a
 * third-party CSV package the licence gate (`pnpm licenses`) would need arguing with (§E-14).
 *
 * MOVED here from `slate/src/features/governance/` on 2026-09-13. It is a dependency-free browser
 * util with no governance in it, and while it sat in one host's feature folder a SHARED package
 * (`docit-market`) imported it — so `coil` could not compile `docit-market` at all and coil-web
 * stopped building. A shared package reaching into one app's private source is a layering violation
 * no alias can paper over: aliasing it for coil would have meant coil forking a copy. Both hosts
 * already alias `~/foundation/*` to this package, so living here costs no new wiring.
 * `pnpm portability:check` now fails on this class.
 */
export function downloadFile(filename: string, content: string, mimeType: string): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/** Quotes any cell containing a comma, a quote or a newline; doubles embedded quotes. */
function escapeCsvCell(value: unknown): string {
  const text = value === null || value === undefined ? "" : String(value);
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function toCsv(headers: string[], rows: unknown[][]): string {
  const lines = [headers, ...rows].map((row) => row.map(escapeCsvCell).join(","));
  return lines.join("\n");
}

export function downloadCsv(filename: string, headers: string[], rows: unknown[][]): void {
  downloadFile(filename, toCsv(headers, rows), "text/csv;charset=utf-8");
}

export function downloadJson(filename: string, data: unknown): void {
  downloadFile(filename, JSON.stringify(data, null, 2), "application/json;charset=utf-8");
}
